import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Building2, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { Field, btnPrimary, inputCls } from "@/components/app/common";

export const normPiva = (v) => { const s = (v || "").toUpperCase().replace(/[^A-Z0-9]/g, ""); return s.length > 2 && /^[A-Z]{2}/.test(s) ? s.slice(2) : s; };
const prefix = (v) => { const s = (v || "").toUpperCase().replace(/[^A-Z0-9]/g, ""); return s.length > 2 && /^[A-Z]{2}/.test(s) ? s.slice(0, 2) : ""; };
export const samePiva = (a, b) => !!normPiva(a) && normPiva(a) === normPiva(b) && (!prefix(a) || !prefix(b) || prefix(a) === prefix(b));

export function useAzienda() {
  const [a, setA] = useState({ ragione_sociale: "", piva: "" });
  useEffect(() => { api.get("/impostazioni/azienda").then((r) => setA(r.data)).catch(() => {}); }, []);
  return a;
}

export function DatiAzienda() {
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/impostazioni/azienda").then((r) => setF(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try { setF((await api.put("/impostazioni/azienda", f)).data); toast.success("Dati azienda salvati"); }
    catch (err) { toast.error(errMsg(err)); } finally { setSaving(false); }
  };
  if (!f) return null;
  return (
    <form onSubmit={save} className="card-soft p-6 space-y-4 lg:col-span-2" data-testid="azienda-form">
      <h2 className="text-lg font-medium flex items-center gap-2"><Building2 className="h-4 w-4 text-[#8C6D62]" />Dati azienda</h2>
      <p className="text-xs text-[#756B64] -mt-2">Usati per controllare che l'AI non scambi la tua azienda (il cliente in fattura) per il fornitore.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Ragione sociale"><Input data-testid="azienda-ragione-input" value={f.ragione_sociale} onChange={(e) => setF({ ...f, ragione_sociale: e.target.value })} className={inputCls} placeholder="Es. Optima S.r.l." /></Field>
        <Field label="Partita IVA"><Input data-testid="azienda-piva-input" value={f.piva} onChange={(e) => setF({ ...f, piva: e.target.value })} className={inputCls} placeholder="Es. IT01234567890" /></Field>
        <Field label="Indirizzo (facoltativo)"><Input data-testid="azienda-indirizzo-input" value={f.indirizzo || ""} onChange={(e) => setF({ ...f, indirizzo: e.target.value })} className={inputCls} placeholder="Via e numero civico" /></Field>
        <div className="grid grid-cols-[1fr_2fr_auto] gap-2">
          <Field label="CAP"><Input data-testid="azienda-cap-input" value={f.cap || ""} onChange={(e) => setF({ ...f, cap: e.target.value })} className={inputCls} /></Field>
          <Field label="Città"><Input data-testid="azienda-citta-input" value={f.citta || ""} onChange={(e) => setF({ ...f, citta: e.target.value })} className={inputCls} /></Field>
          <Field label="Paese"><Input data-testid="azienda-paese-input" maxLength={2} value={f.paese || "IT"} onChange={(e) => setF({ ...f, paese: e.target.value.toUpperCase() })} className={`${inputCls} w-16`} /></Field>
        </div>
      </div>
      <p className="text-xs text-[#756B64]">Ragione sociale, indirizzo e P.IVA compaiono anche nell'intestazione del report PDF.</p>
      <Button type="submit" className={btnPrimary} disabled={saving} data-testid="azienda-save-button">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salva dati azienda"}</Button>
    </form>
  );
}
